import {
  DAILY_DEFAULT_ZOOM_ORIGIN,
  DAILY_DEFAULT_ZOOM_RADIUS,
  DAILY_INTERPOLATION_INITIAL_ZOOM,
} from '../../constants/games/dailyGame';

const clampUnit = (value) => Math.min(1, Math.max(0, value));

const toFiniteNumberOr = (value, fallback) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const pickFirstDefined = (...values) => values.find((value) => value !== undefined && value !== null);

export const normalizeDailyZoomOrigin = (
  origin,
  fallback = DAILY_DEFAULT_ZOOM_ORIGIN,
) => {
  const fallbackX = toFiniteNumberOr(fallback?.x, DAILY_DEFAULT_ZOOM_ORIGIN.x);
  const fallbackY = toFiniteNumberOr(fallback?.y, DAILY_DEFAULT_ZOOM_ORIGIN.y);
  const resolvedX = clampUnit(toFiniteNumberOr(origin?.x, fallbackX));
  const resolvedY = clampUnit(toFiniteNumberOr(origin?.y, fallbackY));
  return { x: resolvedX, y: resolvedY };
};

export const resolveDailyZoomOrigin = (raw, fallback = DAILY_DEFAULT_ZOOM_ORIGIN) =>
  normalizeDailyZoomOrigin(
    {
      x: pickFirstDefined(
        raw?.zoomOrigin?.x,
        raw?.zoom_origin?.x,
        raw?.zoomOriginX,
        raw?.zoom_origin_x,
      ),
      y: pickFirstDefined(
        raw?.zoomOrigin?.y,
        raw?.zoom_origin?.y,
        raw?.zoomOriginY,
        raw?.zoom_origin_y,
      ),
    },
    fallback,
  );

export const normalizeDailyZoomRadius = (
  value,
  fallback = DAILY_DEFAULT_ZOOM_RADIUS,
) => {
  const fallbackRadius = toFiniteNumberOr(fallback, DAILY_DEFAULT_ZOOM_RADIUS);
  const resolved = toFiniteNumberOr(value, fallbackRadius);
  if (resolved <= 0 || resolved > 1) {
    return clampUnit(fallbackRadius);
  }
  return resolved;
};

export const normalizeDailyShareZoomLevel = (
  value,
  fallback = DAILY_INTERPOLATION_INITIAL_ZOOM,
) => {
  const fallbackLevel = toFiniteNumberOr(fallback, DAILY_INTERPOLATION_INITIAL_ZOOM);
  const resolved = toFiniteNumberOr(value, fallbackLevel);
  return resolved > 0 ? resolved : fallbackLevel;
};
